import React from 'react';
import PropTypes from 'prop-types';

import styles from './style.scss';


const PageButton = ({ pageNumber, navigationUrl, ...props }) => (
  <a href={navigationUrl}
    className={styles.pageButton}
    {...props}
    onClick={(e)=>{
      e.preventDefault();
      props.onClick();
    }}>
    <span className={styles.button}>{pageNumber}</span>
  </a>
);

PageButton.propTypes = {
  pageNumber: PropTypes.number,
};

PageButton.defaultProps = {
  pageNumber: 1,
};

export default PageButton;
